import React, { useState, useEffect } from "react";
import Select from "react-select";

import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ApModal from "../../../components/Modal/ApModal";
import ItemTable from "../../../components/Content/ItemTable";
import Summary from "../../../components/Footer/Summary";
import FormAction from "../../../components/Actions/FormAction";

// Model
import { prMasterModel } from "../../../../model/Purchase/PrMasterModel";
import { prDetailModel } from "../../../../model/Purchase/PrDetailModel";
import FileModal from "../../../components/Modal/FileModal";

// Utils
import {
  getDataWithComp,
  getByDocId,
  getDocType,
  getTransType,
  getViewAp,
  getViewItem,
  getAlert,
  formatCurrency,
  parseCurrency,
  addTitleToDocNo,
  randomDelay,
  deleteData,
  getData,
  getMaxDocNo2,
  updateData,
} from "../../../../utils/SamuiUtils";

import {
  formatStringDateToDate,
  formatDateOnChange,
  formatDateTime,
  formatThaiDateUi,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";
import EmployeeModal from "../../../components/Modal/EmployeeModal";

function Form({
  callInitialize,
  mode,
  name,
  maxDocNo,
  getReport,
  masterList,
  setMaxDocNo2,
  setMode,
}) {
  const [formMasterList, setFormMasterList] = useState(prMasterModel());
  // console.debug("formMasterList", formMasterList);
  const [formDetailList, setFormDetailList] = useState([]);
  // console.debug("formDetailList", formDetailList);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [apDataList, setApDataList] = useState([]);
  console.debug("apDataList", apDataList);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [empDataList, setEmpDataList] = useState([]);
  const [Currency, setCurrency] = useState([]);
  const [contactList, setContactList] = useState([]);
  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);
  const [po_h_doc_po_type, setpo_h_doc_po_type] = useState("1");

  // File แนบ
  const [openUploadAttach, setOpenUploadAttach] = useState(false);
  const [showViewAttachModal, setShowViewAttachModal] = useState(false);

  const SaveAS = async () => {
    try {
      const currentPrefix = po_h_doc_po_type === "1" ? "POM" : "POL";
      const maxDoc = await getMaxDocNo2(currentPrefix);

      setFormMasterList((prev) => ({
        ...prev,
        docId: null,
        docNo: maxDoc,
        docDate: formatThaiDateUi(moment()),
        docDueDate: formatThaiDateUi(moment()),
        createdDate: getCreateDateTime(),
        createdByName: window.localStorage.getItem("name") || "",
        createdById: window.localStorage.getItem("emp_id") || "",
        docStatus: 1,
        updateDate: null,
        updateByName: null,
        updateById: null,
        approvedDate: null,
        approvedByName: null,
        approvedById: null,
        cancelDate: null,
        cancelByName: null,
        cancelById: null,
        approvedMemo: null,
        printedStatus: "N",
        printedDate: null,
        printedBy: null,
        docIsPO: 0,
        refDocID: null,
        refDoc: null,
      }));

      setMaxDocNo2(maxDoc);
      setMode("I");
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถสร้างสำเนาได้: " + error.message);
    }
  };

  // การแสดงสถานะใบ
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");
  const [docedit, setDocEdit] = useState(null);

  // ใช้สำหรับตั้งตัวแปรรับข้อมูลแผนกผู้ขอซื้อ
  const [deptName, setDeptName] = useState("");

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setIsLoading(true);
      const docTypeList = await getDocType(1);
      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
      }

      const transTypeList = await getTransType();
      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
      }

      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        const poType = parseInt(po_h_doc_po_type, 10); // แปลงเป็นตัวเลข

        const filteredData = apDataList.filter(
          (ap) => poType === 1 && ap.AP_Type_S === "M"
        );
        console.debug("filteredData", filteredData);
        setApDataList(filteredData);
      }

      const itemDataList = await getViewItem();
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      const CurrencyList = await getData("View_Set_Currency", `1=1`);
      if (CurrencyList && CurrencyList.length > 0) {
        setCurrency(CurrencyList);
      }

      const empDataList = await getDataWithComp(
        "View_Set_Employee",
        `AND Emp_Status = 'Y' ORDER BY Emp_Code ASC`
      );
      if (empDataList && empDataList.length > 0) {
        setEmpDataList(empDataList);
      }

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(apDataList);
        const matchedDoc = masterList.find((item) => item.Doc_No === maxDocNo);
        const docId = matchedDoc ? matchedDoc.Doc_ID : null;

        if (docId) {
          const conditions = `DocCode_ID = 2 AND Comp_Id = ${matchedDoc.Comp_Id} AND Doc_ID = ${docId}`;
          const image = await getData("Upload_File_List", conditions);

          if (Array.isArray(image) && image.length > 0) {
            const fileNames = image.map((img) => img.File_Name);

            setSelectedFiles(fileNames);
          } else {
            setSelectedFiles([]);
          }
        } else {
          console.warn("ไม่พบ Doc_ID ที่ตรงกับ maxDocNo");
          setSelectedFiles([]);
        }
      }
      if (mode !== "U") {
        const newDocNo = await getMaxDocNo2();
        //  const newDocNo = await getMaxDocNo2();
        // console.debug("newDocNo", newDocNo);
        // setMaxDocNo2(newDocNo);
        setMaxDocNo2(addTitleToDocNo("POM", newDocNo));
      }

      // Default สินค้าของโรงน้ำแข็ง ตาม DocType
      if (localStorage.getItem("company") === "2") {
        await handleChangeMaster({ target: { name: "docType", value: "1" } });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message);
    }
  };

  // ทำซ้ำรายการสินค้า (รูปแบบเดียวกับ Quotation)
  // ทำซ้ำรายการสินค้า (รูปแบบเดียวกับ Quotation)
  const handleDuplicateRow = (index) => {
    try {
      if (
        !Array.isArray(formDetailList) ||
        index < 0 ||
        index >= formDetailList.length
      )
        return;

      const currentItem = formDetailList[index];
      const itemsToDuplicate = [{ ...currentItem, line: null }];

      // Check for associated Spec row
      if (index + 1 < formDetailList.length) {
        const nextItem = formDetailList[index + 1];
        if (nextItem.isSpecRow && nextItem.parentId === currentItem.itemId) {
          itemsToDuplicate.push({ ...nextItem, line: null });
        }
      }

      // If the current item is itself a Spec row, we might want to prevent duplication or handle it?
      // Usually "Duplicate" button is on the main row.
      // If the user clicks duplicate on a Spec row, what happens?
      // In ItemTable, the button might be hidden or disabled for Spec rows.
      // Assuming button is available on main row.

      const newList = [
        ...formDetailList.slice(0, index + itemsToDuplicate.length), // Insert after the group (Main + Spec) if Spec exists
        // Wait, if we duplicate Main, we want Main(Copy) + Spec(Copy) to appear AFTER Main + Spec.
        // If index is Main, and index+1 is Spec. We want to insert at index + 2.
      ];

      // Re-evaluating insertion point
      let insertAtIndex = index + 1;
      if (itemsToDuplicate.length > 1) {
        insertAtIndex = index + 2;
      }

      // Check if we are duplicating a Spec row directly (should be prevented by UI ideally, but safety check)
      if (currentItem.isSpecRow) return;

      const newListSafe = [...formDetailList];
      newListSafe.splice(insertAtIndex, 0, ...itemsToDuplicate);

      setFormDetailList(newListSafe);
    } catch (error) {
      getAlert("FAILED", error.message || "ไม่สามารถทำซ้ำรายการได้");
    }
  };

  const getModelByNo = async (apDataList) => {
    try {
      // ดึงข้อมูลเอกสารจาก PR_H
      const [findMaster] = await Promise.all([getDataWithComp("PO_H", "")]);
      const fromDatabase = findMaster.find((po) => po.Doc_No === maxDocNo);

      if (!fromDatabase) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ดึงข้อมูลผู้ขายจาก apDataList โดยใช้ AP_ID
      const fromViewAp = apDataList.find(
        (ap) => ap.AP_Id === fromDatabase.AP_ID
      );

      if (!fromViewAp) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลผู้ขาย");
      }

      // ดึงข้อมูลจาก VIEW API_0101_PR_H
      const [findViewMaster] = await Promise.all([
        getDataWithComp("API_0201_PO_H", ""),
      ]);
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);
      setStatusName(fromView.DocStatus_Name);
      setStatusColour(fromView.DocStatus_Colour);
      setDocEdit(fromView?.Doc_edit);

      // setDeptName(fromView.Dept_Name);

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseFloat(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseFloat(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseFloat(itemSelected.Item_Discount) || 0;
        const itemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        if (itemDisType === "2") {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        // Check if it is a Spec row (robust check)
        const isSpecRow =
          (!itemSelected.Item_Code || itemSelected.Item_Code === "") &&
            (!itemSelected.Item_Id ||
              itemSelected.Item_Id === 0 ||
              itemSelected.Item_Id === "0") &&
            itemSelected.Item_Name
            ? true
            : false;

        return {
          ...prDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemNameEN: itemSelected.Item_Name_En,
          itemQty: isSpecRow ? "" : formatCurrency(itemQty),
          itemUnit: isSpecRow ? "" : itemSelected.Item_Unit,
          itemPriceUnit: isSpecRow ? "" : formatCurrency(itemPriceUnit),
          itemDiscount: isSpecRow ? "" : formatCurrency(itemDiscount),
          itemDisType,
          itemTotal: isSpecRow ? "" : itemTotal,
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
          isGift: itemSelected.Is_Free === "Y" ? true : false,
          isSpecRow: isSpecRow,
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "PO_D",
        fromDatabase.Doc_Id,
        `ORDER BY Line ASC`
      );

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) => {
          const newItem = createNewRow(formDetailList.length + index, item);

          // Find parent for Spec row
          if (newItem.isSpecRow) {
            // Find the nearest previous item that is NOT a spec row (and presumably has an ID)
            for (let i = index - 1; i >= 0; i--) {
              const prevItem = fromDetail[i];
              // Assuming valid parent has Item_Code or Item_Id
              if (prevItem.Item_Code || prevItem.Item_Id) {
                newItem.parentId = prevItem.Item_Id;
                break;
              }
            }
          }
          return newItem;
        });
        setFormDetailList(newFormDetails);

        setFormMasterList({
          ...formMasterList,
          docId: fromDatabase.Doc_Id,
          docNo: fromDatabase.Doc_No,
          docDate: formatThaiDateUi(fromDatabase.Doc_Date || null),
          docDueDate: formatThaiDateUi(fromDatabase.Doc_DueDate || null),
          docStatus: fromDatabase.Doc_Status,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          docIsPO: fromDatabase.Doc_Is_PO,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: fromDatabase.Ref_DocDate,
          compId: fromDatabase.Comp_Id,
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          apID: fromDatabase.AP_ID,
          apCode: fromDatabase.AP_Code,
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromViewAp.AP_Credit,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,
          po_by_id: fromDatabase.po_by_id,
          // prByCode: formMasterList.Emp_Code,
          // prByName: formMasterList.Emp_Name,
          doc_currency: fromDatabase.Doc_Currency,
          doc_shipment: fromDatabase.Doc_Shipment,
          doc_delivery: fromDatabase.Doc_Delivery,
          doc_contact: fromDatabase.Doc_contact,
          doc_email: fromViewAp.AP_Email,
          po_ref: fromDatabase.PO_Ref,
          po_term_payment: fromDatabase.PO_Term_Payment,
          po_deliver_time: fromDatabase.PO_Deliver_Time,

          // ข้อมูลผู้ขาย
          apName: fromViewAp.AP_Name,
          apAdd1: fromViewAp.AP_Add1,
          apAdd2: fromViewAp.AP_Add2,
          apAdd3: fromViewAp.AP_Add3,
          apProvince: fromViewAp.AP_Province,
          apZipcode: fromViewAp.AP_Zipcode,
          apTaxNo: fromViewAp.AP_TaxNo,
        });

        setIsVatChecked(fromDatabase.IsVat === 1);
        if (mode === "U") {
          getDepartmentForEmp(fromDatabase?.PO_By_id);
          if (fromDatabase && fromDatabase.Doc_No.startsWith("POM")) {
            setpo_h_doc_po_type("1");
          } else {
            setpo_h_doc_po_type("2");
          }
        }

        const discountValueType = parseFloat(fromDatabase.Discount_Value_Type);
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    const newValue = selectedDiscountValueType === value ? null : value;

    setSelectedDiscountValueType(newValue);

    setFormMasterList((prev) => ({
      ...prev,
      discountValueType: newValue !== null ? Number(newValue) : null,
    }));
  };

  const handleSubmit = async () => {
    try {
      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      setIsLoading(true);
      await randomDelay();

      // หาค่าสูงของ DocNo ใน PR_H ก่อนบันทึก
      // const findMaxDocNo = await getDataWithComp(
      //   "PO_H",
      //   "ORDER BY Doc_No DESC"
      // );
      // const maxDoc = getMaxDocNo(findMaxDocNo, "PO");
      let newMaxDoc = maxDocNo;

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.apID && !formMasterList.apCode) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่า formMasterList.po_by_id
      if (!formMasterList.po_by_id) {
        setIsLoading(false);
        console.debug("formMasterList", formMasterList);
        getAlert("FAILED", "กรุณาเลือกผู้ขอซื้อ");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า po_by_id
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (
          (item.isGift !== true || item.isGift === undefined) &&
          !item.isSpecRow &&
          (!item.itemQty || parseFloat(item.itemQty) === 0)
        ) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return;
        }
        if (
          (item.isGift !== true || item.isGift === undefined) &&
          !item.isSpecRow &&
          (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0)
        ) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        // if (!item.whId || parseInt(item.whId) === 13) {
        //     getAlert("FAILED", `กรุณาเลือกคลังสินค้าของสินค้า ${item.itemName}`);
        //     return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        // }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: newMaxDoc,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
        doc_status: parseInt("1", 10),
        doc_code: parseInt("1", 10),
        doc_type: parseInt(formMasterList.docType, 10),
        doc_for: formMasterList.docFor,
        doc_is_po: parseInt("0", 10),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: window.localStorage.getItem("company"),
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ap_id: parseInt(formMasterList.apID, 10),
        ap_code: formMasterList.apCode,
        action_hold: parseInt("0", 10),
        discount_value: parseFloat(formMasterList.discountValue || 0.0),
        discount_value_type: parseInt(selectedDiscountValueType, 10),
        discount_cash: parseFloat("0.00"),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseFloat("0.00"),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseInt("1", 10) : parseInt("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseInt(formMasterList.creditTerm, 10),
        credit_term_1_day: parseInt("0", 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        po_by_id: parseInt(formMasterList.po_by_id, 10),
        doc_currency: formMasterList.doc_currency
          ? formMasterList.doc_currency
          : "THB",
        doc_shipment: formMasterList.doc_shipment,
        doc_delivery: formMasterList.doc_delivery,
        doc_contact: formMasterList.doc_contact,
        po_ref: formMasterList.po_ref,
        po_term_payment: formMasterList.po_term_payment,
        po_deliver_time: formMasterList.po_deliver_time,
        doc_email: formMasterList.doc_email,
        // po_h_doc_po_type: parseInt(formMasterList.po_by_id, 10),
      };

      // For Log PR_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-po-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "PO_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        // ส่งข้อมูลรายละเอียดหากพบ Doc_Id
        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseInt(getDocIdResponse.data[0].Doc_Id, 10);
          let index = 1;

          const detailPromises = formDetailList.map(async (item) => {
            const formDetailData = {
              doc_id: parseInt(docId, 10),
              line: index,
              item_id: item.isSpecRow ? 0 : parseInt(item.itemId || 0, 10),
              item_code: item.isSpecRow ? "" : item.itemCode,
              item_name: item.itemName,
              item_name_en: item.itemNameEN,
              item_qty: item.isSpecRow
                ? 0
                : parseFloat(item.itemQty.replace(/,/g, "")) || 0,
              item_unit: item.isSpecRow ? "" : item.itemUnit,
              item_price_unit: item.isSpecRow
                ? 0
                : parseCurrency(item.itemPriceUnit),
              item_discount: item.isSpecRow
                ? 0
                : parseCurrency(item.itemDiscount),
              item_distype:
                item.itemDisType === "1"
                  ? parseInt("1", 10)
                  : parseInt("2", 10),
              item_total: item.isSpecRow ? 0 : parseCurrency(item.itemTotal),
              item_status: parseInt("1", 10),
              wh_id: item.isSpecRow ? 0 : parseInt(item.whId, 10),
              zone_id: parseInt("1", 10),
              lt_id: parseInt("1", 10),
              ds_seq: formatDateTime(new Date()),
              is_free: item.isGift ? "Y" : "N",
            };
            index++;

            // For Log PR_D
            // console.log("formDetailData : ", formDetailData);

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-po-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          const detailResponses = await Promise.all(detailPromises);
          const failedDetail = detailResponses.find(({ data }) => data.status !== "OK");
          if (failedDetail) {
            throw new Error(failedDetail.data.message || "บันทึกรายละเอียดสินค้าไม่สำเร็จ");
          }
          if (selectedFiles.length > 0) {
            try {
              const imageSources = selectedFiles.map((file) => file);
              const compId = window.localStorage.getItem("company");
              const payId = docId;
              const DocCode_ID = 2;
              const emp_name = window.localStorage.getItem("name");
              const file_status = "Y";

              const response = await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/upload-file`,
                {
                  comp_id: compId,
                  doc_id: payId,
                  DocCode_ID,
                  upload_by: emp_name,
                  file_status,
                  files: imageSources,
                }
              );
              console.debug(response);
              if (response.data.status !== "SUCCESS") {
                console.error("อัปโหลดไฟล์ล้มเหลว:", response.data.message);
                getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
              }
            } catch (error) {
              console.error("เกิดข้อผิดพลาดขณะอัปโหลดไฟล์:", error);
              getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
            }
          }
        }
        await Axios.post(
          "/api/memo2text",
          {
            Comp_name: "ENCOT",
            Comp_id: parseInt(localStorage.getItem("company"), 10),
            Prod_uat: process.env.REACT_APP_PROD_UAT,
            Doc_type: "PO",
            Doc_no: formMasterData.doc_no,
            Status: "Save",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      setIsLoading(true);
      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.apID && !formMasterList.apCode) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่า formMasterList.po_by_id
      if (!formMasterList.po_by_id) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกผู้ขอซื้อ");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า po_by_id
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (
          !item.isSpecRow &&
          (!item.itemQty || parseFloat(item.itemQty) === 0)
        ) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (
          (item.isGift !== true || item.isGift === undefined) &&
          !item.isSpecRow &&
          (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0)
        ) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        // if (!item.whId || parseInt(item.whId) === 13) {
        //     getAlert("FAILED", `กรุณาเลือกคลังสินค้าของสินค้า ${item.itemName}`);
        //     return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        // }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API

      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
        doc_status: 1,
        doc_code: parseInt(formMasterList.docCode, 10),
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_po: parseInt(formMasterList.docIsPO, 10),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: formMasterList.compId,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ap_id: parseInt(formMasterList.apID, 10),
        ap_code: formMasterList.apCode,
        action_hold: parseInt(formMasterList.actionHold, 10),
        discount_value: parseFloat(formMasterList.discountValue || 0.0),
        discount_value_type: parseInt(formMasterList.discountValueType, 10),
        discount_cash: parseFloat(formMasterList.discountCash),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseFloat(formMasterList.discountTransport),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseInt("1", 10) : parseInt("2", 10),
        doc_seq: formMasterList.docSEQ,
        credit_term: parseInt(formMasterList.creditTerm, 10),
        credit_term_1_day: parseInt(formMasterList.creditTerm1Day, 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode,
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        approved_date: formatThaiDateUiToDate(formMasterList.approvedDate),
        approved_by_name: formMasterList.approvedByName,
        approved_by_id: formMasterList.approvedById,
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        approved_memo: formMasterList.approvedMemo,
        printed_status: formMasterList.printedStatus,
        printed_date: formatThaiDateUiToDate(formMasterList.printedDate),
        printed_by: formMasterList.printedBy,
        po_by_id: parseInt(formMasterList.po_by_id, 10),
        doc_currency: formMasterList.doc_currency,
        doc_shipment: formMasterList.doc_shipment,
        doc_delivery: formMasterList.doc_delivery,
        doc_contact: formMasterList.doc_contact,
        doc_email: formMasterList.doc_email,
        po_ref: formMasterList.po_ref,
        po_term_payment: formMasterList.po_term_payment,
        po_deliver_time: formMasterList.po_deliver_time,
        // po_h_doc_po_type: parseInt(formMasterList.po_by_id, 10),
      };

      // For Log PR_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-po-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        const docId = parseInt(formMasterList.docId, 10);
        await deleteData("PO_D", `WHERE Doc_ID = ${docId}`);

        let index = 1;

        const detailPromises = formDetailList.map(async (item) => {
          const formDetailData = {
            doc_id: parseInt(docId, 10),
            line: index,
            item_id: item.isSpecRow ? 0 : parseInt(item.itemId || 0, 10),
            item_code: item.isSpecRow ? "" : item.itemCode,
            item_name: item.itemName,
            item_name_en: item.itemNameEN,
            item_qty: item.isSpecRow
              ? 0
              : parseFloat(item.itemQty.replace(/,/g, "")) || 0,
            item_unit: item.isSpecRow ? "" : item.itemUnit,
            item_price_unit: item.isSpecRow
              ? 0
              : parseCurrency(item.itemPriceUnit),
            item_discount: item.isSpecRow
              ? 0
              : parseCurrency(item.itemDiscount),
            item_distype: item.isSpecRow ? 1 : item.itemDisType,
            item_total: item.isSpecRow ? 0 : parseCurrency(item.itemTotal),
            item_status: parseInt("1", 10),
            wh_id: item.isSpecRow ? 0 : parseInt(item.whId, 10),
            zone_id: parseInt(item.zoneId, 10),
            lt_id: parseInt(item.ltId, 10),
            ds_seq: item.dsSeq,
            is_free: item.isGift ? "Y" : "N",
          };
          index++;

          // For Log PR_D
          // console.log("formDetailData : ", formDetailData);

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-po-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        const detailResponses = await Promise.all(detailPromises);
        const failedDetail = detailResponses.find(({ data }) => data.status !== "OK");
        if (failedDetail) {
          throw new Error(failedDetail.data.message || "บันทึกรายละเอียดสินค้าไม่สำเร็จ");
        }
        console.debug("selectedFiles", selectedFiles);

        if (selectedFiles.length > 0) {
          try {
            // กรองไฟล์ที่ไม่ใช่ลิงก์
            const filteredFiles = selectedFiles.filter(
              (file) =>
                !file.startsWith(
                  "https://encotech.s3.ap-southeast-1.amazonaws.com/"
                )
            );

            const compId = window.localStorage.getItem("company");
            const payId = docId;
            const DocCode_ID = 2;
            const emp_name = window.localStorage.getItem("name");
            const file_status = "Y";

            console.debug("response", {
              comp_id: compId,
              doc_id: payId,
              DocCode_ID,
              upload_by: emp_name,
              file_status,
              files: filteredFiles, // ส่งไฟล์ที่กรองแล้ว
            });

            const response = await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/upload-file`,
              {
                comp_id: compId,
                doc_id: payId,
                DocCode_ID,
                upload_by: emp_name,
                file_status,
                files: filteredFiles, // ส่งไฟล์ที่กรองแล้ว
              }
            );

            if (response.data.status !== "SUCCESS") {
              console.error("อัปโหลดไฟล์ล้มเหลว:", response.data.message);
              getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
            }
          } catch (error) {
            console.error("เกิดข้อผิดพลาดขณะอัปโหลดไฟล์:", error);
            getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
          }
        }
        await Axios.post(
          "/api/memo2text",
          {
            Comp_name: "ENCOT",
            Comp_id: parseInt(localStorage.getItem("company"), 10),
            Prod_uat: process.env.REACT_APP_PROD_UAT,
            Doc_type: "PO",
            Doc_no: formMasterData.doc_no,
            Status: "Save",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API

      setIsLoading(true);
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseInt("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // For Log PR_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-po-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
      setIsLoading(false);
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = async (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList

    // จำกัดความยาวไม่ให้เกิน 255 ตัวอักษร
    if (value.length > 255) return;

    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));

    // ใบขอซื้อ เมื่อเลือกประเภทเอกสารแล้ว ตอนเพิ่มสินค้าให้กรองเฉพาะสินค้า ตามกลุ่มสินค้าที่กำหนดไว้ (เฉพาะ โรงน้ำแข็งนะคับ โรงน้ำแสดงสินค้าทั้งหมด ตามปกติ ก่อน)
    if (localStorage.getItem("company") === "2" && name === "docType") {
      // กำหนด mapping itemGroup สำหรับแต่ละประเภทเอกสาร
      const itemGroupMapping = {
        1: ["2", "5", "6", "9", "10", "21", "22"], // ซื้อสินค้า
        2: ["1", "23", "24", "25", "26", "27"], // บริการ
        3: ["23"], // โปรเจค
        4: ["28"], // ของขวัญ
        5: ["25"], // โอที
      };

      const itemGroups = itemGroupMapping[value];

      if (itemGroups) {
        try {
          // ตามที่พี่คินแจ้งมา
          const itemDataList = await getDataWithComp(
            "Tb_Set_Item",
            `AND Item_Group IN ('${itemGroups.join(
              "','"
            )}') AND Item_Status = 'Y' ORDER BY Item_Code ASC`
          );

          if (itemDataList && itemDataList.length > 0) {
            setItemDataList(itemDataList);
          }
        } catch (error) {
          getAlert("FAILED", error.response?.data?.message || error.message);
        }
      } else {
        try {
          // ถ้าไม่มีการเลือกประเภทเอกสาร หรือกรณี default ให้ดึงข้อมูลทั้งหมด
          const itemDataList = await getViewItem();

          if (itemDataList && itemDataList.length > 0) {
            setItemDataList(itemDataList);
          }
        } catch (error) {
          getAlert("FAILED", error.response?.data?.message || error.message);
        }
      }
    }
  };

  const handlesetpo_h_doc_po_type = (e) => {
    const { value } = e.target;
    setpo_h_doc_po_type(value); // แค่ set state พอ
    if (value === "2") {
      setIsVatChecked(true);
    } else {
      setIsVatChecked(false);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const prefix = po_h_doc_po_type === "1" ? "POM" : "POL";

      if (mode !== "U") {
        const newDocNo = await getMaxDocNo2(prefix);
        setMaxDocNo2(addTitleToDocNo(prefix, newDocNo));
      }

      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        const poType = parseInt(po_h_doc_po_type, 10);
        const filteredData = apDataList.filter(
          (ap) =>
            (poType === 1 && ap.AP_Type_S === "M") ||
            (poType === 2 && ap.AP_Type_S === "L")
        );
        setApDataList(filteredData);
      }
    };

    fetchData();
  }, [po_h_doc_po_type]);

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;

    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  const handleChangeDetail = (index, field, value) => {
    // console.debug("handleChangeDetail", index, field, value);
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    const numericFields = ["itemQty", "itemPriceUnit", "itemDiscount"];
    if (numericFields.includes(field) && !/^\d*\.?\d*$/.test(value)) {
      return;
    }

    const updatedList = [...formDetailList];
    updatedList[index][field] = value;

    const itemQty = parseFloat(parseCurrency(updatedList[index].itemQty)) || 0;
    const itemPriceUnit =
      parseFloat(parseCurrency(updatedList[index].itemPriceUnit)) || 0;
    const itemDiscount =
      parseFloat(parseCurrency(updatedList[index].itemDiscount)) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;

    if (itemDisType === "2") {
      itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
    } else {
      itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
    }

    updatedList[index].itemTotal = itemTotal;
    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    const value = updatedList[index][field];

    let parsed = 0;

    if (typeof value === "string") {
      parsed = parseCurrency(value.replace(/,/g, ""));
    } else if (typeof value === "number") {
      parsed = value;
    } else if (value != null && typeof value.toString === "function") {
      parsed = parseCurrency(value.toString().replace(/,/g, ""));
    }

    updatedList[index][field] = parsed || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseFloat(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  const getDepartmentForEmp = async (empId) => {
    try {
      if (!empId) {
        console.warn("❗ getDepartmentForEmp: empId เป็น undefined หรือ null");
        return;
      }

      console.debug("🔍 กำลังดึงข้อมูลแผนกสำหรับพนักงาน ID:", empId);

      const department = await getDataWithComp(
        "View_Set_Employee",
        `AND Emp_Id = ${empId}`
      );

      console.debug("✅ ผลลัพธ์จาก getDataWithComp:", department);

      if (department && department.length > 0) {
        const empData = department[0];

        setDeptName(empData.Dept_Name);
        setFormMasterList((prev) => ({
          ...prev,
          po_by_id: empData.Emp_Id,
          prByCode: empData.Emp_Code,
          prByName: empData.Emp_Name,
        }));

        console.debug("🎯 อัปเดตข้อมูลแผนกและพนักงานเรียบร้อย:", {
          po_by_id: empData.Emp_Id,
          prByCode: empData.Emp_Code,
          prByName: empData.Emp_Name,
          deptName: empData.Dept_Name,
        });
      } else {
        console.warn("⚠️ ไม่พบข้อมูลแผนกสำหรับพนักงานที่เลือก");
      }
    } catch (error) {
      console.error("❌ เกิดข้อผิดพลาดใน getDepartmentForEmp:", error);
      getAlert("FAILED", error.message || error);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleRemoveImage = async (index) => {
    const fileToRemove = selectedFiles[index];

    // ถ้าตัวที่ลบเป็น URL ตามเงื่อนไขให้ลบจากฐานข้อมูล
    if (
      fileToRemove.startsWith(
        "https://encotech.s3.ap-southeast-1.amazonaws.com/"
      )
    ) {
      await deleteData(
        "Upload_File_List",
        `WHERE File_Name= '${fileToRemove}'`
      );
    }

    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));

    if (selectedFiles.length === 1) {
      setShowModal(false);
    }
  };

  function handleInputFileChange(e) {
    const files = e.target.files;
    const file = files ? files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedFiles((prev) => [...prev, e.target?.result]);
      };
      reader.readAsDataURL(file);
    }
  }

  const handleShowModal = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*, .pdf, .doc, .docx, .xls, .xlsx";
    input.multiple = false;
    input.onchange = (e) => handleInputFileChange(e);
    input.click();
    setShowModal(true);
  };

  const [showViewModal, setShowViewModal] = useState(false);
  const handleClose = () => {
    setShowViewModal(false);
  };

  // SET EMP
  const [showEmpModal, setShowEmpModal] = useState(false);
  const handleEmpShow = () => setShowEmpModal(true);
  const handleEmpClose = () => setShowEmpModal(false);
  const onRowSelectEmp = (empSelected) => {
    try {
      // setFormMasterList({
      //   ...formMasterList,
      //   po_by_id: empSelected.Emp_Id,
      //   prByCode: empSelected.Emp_Code,
      //   prByName: empSelected.Emp_Name,
      // });

      // ค้นหาแผนกผู้ขอซื้อ
      getDepartmentForEmp(empSelected.Emp_Id);

      handleEmpClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET AP
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = (apSelected) => {
    try {
      // สร้างรายการผู้ติดต่อและอีเมล
      const contacts = [];
      if (apSelected.AP_Contact) contacts.push(apSelected.AP_Contact);
      if (apSelected.AP_Contact2) contacts.push(apSelected.AP_Contact2);

      const contactsemail = [];
      if (apSelected.AP_Email) contactsemail.push(apSelected.AP_Email);
      if (apSelected.AP_Email2) contactsemail.push(apSelected.AP_Email2);

      // สร้าง options สำหรับ dropdown
      const contactOptions = contacts.map((c) => ({ label: c, value: c }));

      // ตั้งค่า default เป็น contact และ email แรก
      const defaultContact = contacts[0] || "";
      const defaultEmail = contactsemail[0] || "";

      // เซ็ตข้อมูลลง form
      setFormMasterList({
        ...formMasterList,
        apID: apSelected.AP_Id,
        apCode: apSelected.AP_Code,
        apName: apSelected.AP_Name,
        apAdd1: apSelected.AP_Add1,
        apAdd2: apSelected.AP_Add2,
        apAdd3: apSelected.AP_Add3,
        apProvince: apSelected.AP_Province,
        apZipcode: apSelected.AP_Zipcode,
        apTaxNo: apSelected.AP_TaxNo,
        doc_contact: defaultContact,
        doc_email: defaultEmail,
        creditTerm: apSelected.AP_Credit,
      });

      setContactList(contactOptions); // สำหรับใช้ใน dropdown
      handleApClose(); // ปิด modal
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedDocNo, setSelectedDocNo] = useState(null);
  const onRowSelectItem = (itemsSelected) => {
    try {
      // หารายการ itemId ที่เลือกมาใหม่ทั้งหมด (ไม่ซ้ำกัน)
      const uniqueItems = Array.from(
        new Set(itemsSelected.map((item) => item.Item_Id))
      ).map((id) => {
        return itemsSelected.find((item) => item.Item_Id === id);
      });

      const newItemsToAdd = uniqueItems.filter(
        (newItem) =>
          !formDetailList.some(
            (existing) => existing.itemId === newItem.Item_Id
          )
      );

      const newItemDetails = [];

      newItemsToAdd.forEach((itemSelected) => {
        let itemTotal = 1 * itemSelected.Item_Cost;

        // Add Main Item
        newItemDetails.push({
          line: null,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemNameEN: itemSelected.Item_Name_EN,
          itemQty: formatCurrency(1),
          itemUnit: itemSelected.Item_Unit_IN,
          itemPriceUnit: formatCurrency(itemSelected.Item_Cost || 0),
          itemDiscount: formatCurrency(0),
          itemDisType: "1",
          itemTotal: itemTotal,
          itemStatus: itemSelected.Item_Status,
          whId: null,
          whName: itemSelected.WH_Name,
          zoneId: null,
          ltId: null,
          dsSeq: null,
          parentId: null,
          isSpecRow: false,
        });

        // Add Spec Row if available
        if (itemSelected.Is_Spec_Show === "Y" && itemSelected.Item_Spec) {
          newItemDetails.push({
            line: null,
            itemId: null,
            itemCode: "",
            itemName: itemSelected.Item_Spec, // For display
            itemNameEN: itemSelected.Item_Spec, // For Purchase Request display (based on ItemTable logic)
            itemQty: "",
            itemUnit: "",
            itemPriceUnit: "",
            itemDiscount: "",
            itemDisType: "",
            itemTotal: "",
            itemStatus: "",
            whId: null,
            whName: "",
            zoneId: null,
            ltId: null,
            dsSeq: null,
            isSpecRow: true,
            parentId: itemSelected.Item_Id,
          });
        }
      });

      // รวมรายการเดิมกับของใหม่
      setFormDetailList([...formDetailList, ...newItemDetails]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const onRowSelectItem02 = () => {
    try {
      if (po_h_doc_po_type !== "2") {
        handleItemClose();
        return;
      }

      const emptyItem = {
        line: null,
        itemId: 1,
        itemCode: null,
        itemName: "",
        itemNameEN: "",
        itemQty: formatCurrency(0),
        itemUnit: "",
        itemPriceUnit: formatCurrency(0),
        itemDiscount: formatCurrency(0),
        itemDisType: "1",
        itemTotal: 0,
        itemStatus: "Y",
        whId: null,
        whName: "",
        zoneId: null,
        ltId: null,
        dsSeq: null,
        parentId: null,
        isSpecRow: false,
        isGift: false,
      };

      setFormDetailList((prev) => [...prev, emptyItem]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const onRowSelectItemForEdit = (itemSelected, rowIndex) => {
    try {
      const existingItem = formDetailList[rowIndex];
      const itemTotal = 1 * itemSelected.Item_Cost;

      const updatedItem = {
        line: existingItem?.line || null,
        itemId: itemSelected.Item_Id,
        itemCode: itemSelected.Item_Code,
        itemName: itemSelected.Item_Name,
        itemNameEN: itemSelected.Item_Name_EN,
        itemQty: formatCurrency(1),
        itemUnit: itemSelected.Item_Unit_ST,
        itemPriceUnit: formatCurrency(itemSelected.Item_Cost || 0),
        itemDiscount: formatCurrency(0),
        itemDisType: "1",
        itemTotal: itemTotal,
        itemStatus: itemSelected.Item_Status,
        whId: existingItem?.whId || null,
        whName: existingItem?.whName || itemSelected.WH_Name,
        zoneId: existingItem?.zoneId || null,
        ltId: existingItem?.ltId || null,
        dsSeq: existingItem?.dsSeq || null,
        parentId: null,
        isSpecRow: false,
      };

      setFormDetailList((prevList) => {
        const newList = [...prevList];

        // 1. Remove associated Spec row if it exists
        // Check if the next item is a Spec row for the *old* item
        if (rowIndex + 1 < newList.length) {
          const nextItem = newList[rowIndex + 1];
          if (
            nextItem.isSpecRow &&
            nextItem.parentId === existingItem.itemId
          ) {
            newList.splice(rowIndex + 1, 1);
          }
        }

        // 2. Update the main item
        newList[rowIndex] = updatedItem;

        // 3. Add new Spec row if applicable
        if (itemSelected.Is_Spec_Show === "Y" && itemSelected.Item_Spec) {
          const specRow = {
            line: null,
            itemId: null,
            itemCode: "",
            itemName: itemSelected.Item_Spec,
            itemNameEN: itemSelected.Item_Spec,
            itemQty: "",
            itemUnit: "",
            itemPriceUnit: "",
            itemDiscount: "",
            itemDisType: "",
            itemTotal: "",
            itemStatus: "",
            whId: null,
            whName: "",
            zoneId: null,
            ltId: null,
            dsSeq: null,
            isSpecRow: true,
            parentId: itemSelected.Item_Id,
          };
          newList.splice(rowIndex + 1, 0, specRow);
        }

        return newList;
      });

      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const handleRemoveRow = (index) => {
    const rowToRemove = formDetailList[index];
    const newList = [...formDetailList];

    // Remove the selected row
    newList.splice(index, 1);

    // Check if the next row (originally at index + 1) is a Spec row belonging to the removed item
    // Note: Since we removed one item, the next item is now at 'index' in newList,
    // BUT we should check the ORIGINAL list to be sure about the relationship before modifying newList further,
    // or just check if the item now at 'index' in newList is a Spec row.
    // However, checking the original list is safer to match parentId.

    if (index + 1 < formDetailList.length) {
      const nextItem = formDetailList[index + 1];
      if (
        nextItem.isSpecRow &&
        nextItem.parentId === rowToRemove.itemId
      ) {
        // Remove the spec row as well
        // It is now at 'index' in newList because we spliced the previous one
        newList.splice(index, 1);
      }
    }

    setFormDetailList(newList);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseFloat(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseFloat(formMasterList.discountValue || 0);
    let receiptDiscount = 0;

    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseFloat(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseFloat(grandTotal));
  }, [subFinal, vatAmount]);

  const updateStatus = async (Doc_No) => {
    try {
      const newStatus = 4;
      const values = { Doc_Status: newStatus };
      const where = { Doc_No };

      console.debug("📌 กำลังอัปเดต PO_H:", values, where);

      const res = await updateData("PO_H", values, where);
      console.debug("🔍 ผลลัพธ์ updateData:", res);

      if (res && res.rowsAffected && res.rowsAffected[0] > 0) {
        console.debug("✅ อัปเดตสถานะสำเร็จ! กำลังโหลดข้อมูลใหม่...");

        await new Promise((resolve) => setTimeout(resolve, 100));

        setTimeout(() => {
          window.location.reload();
        }, 300);
      } else {
        throw new Error(
          "⚠️ ไม่สามารถอัปเดตสถานะได้ หรือไม่มีข้อมูลถูกเปลี่ยนแปลง"
        );
      }
    } catch (error) {
      console.error("❌ อัปเดตล้มเหลว:", error);
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาดในการอัปเดต");
    }
  };

  const handleConfirmtModalBeforeUpdate = (docNo) => {
    let shouldShowModal = false;

    // ตรวจสอบ `formDetailList` ว่าข้อมูลครบถ้วนหรือไม่
    formDetailList.forEach((item) => {
      const itemQty = Number(item.itemQty);
      const itemRecBalance = Number(item.itemRecBalance);

      if (itemQty !== itemRecBalance) {
        shouldShowModal = true;
      }
    });

    if (shouldShowModal) {
      getAlert(
        "CONFIRM",
        "มีรายการที่ยังไม่ได้รับสินค้าครบ ต้องการปิดงาน PO หรือไม่?",
        () => {
          updateStatus(docNo); // ✅ เรียก updateStatus ถ้าผู้ใช้กด OK
        }
      );
    } else {
      updateStatus(docNo); // ✅ ปิดงาน PO ได้เลยถ้าเงื่อนไขผ่าน
    }
  };

  const handleOpenConfirmModal = (docNo) => {
    setSelectedDocNo(docNo);
    setShowConfirmModal(true);
  };

  const handleConfirmUpdateStatus = () => {
    if (selectedDocNo) {
      updateStatus(selectedDocNo);
    }
    setShowConfirmModal(false);
  };
  useEffect(() => {
    // เรียกใช้ getViewItem  เพิ่มSetitemDatalist อีกครั้งเมื่อ showItemModal
    if (showItemModal) {
      getViewItem().then((data) => {
        setItemDataList(data);
      }).catch((error) => {
        getAlert("FAILED", error.message || "ไม่สามารถดึงข้อมูลสินค้าได้");
      });
    }
  }, [showItemModal]);
  return (
    <>
      <Breadcrumbs
        page={maxDocNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        items={[
          { name: "จัดซื้อสินค้า", url: "/purchase" },
          { name: name, url: "/purchase-request" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        onHandleClick={() => {
          const docNo = formMasterList?.docNo || ""; // ป้องกัน undefined
          const prefix = docNo?.match(/^[A-Z]+/g)?.[0] || "";
          const reportType =
            prefix === "POM" ? "PO_OUT" : prefix === "POL" ? "PO_IN" : "PO_OUT";
          getReport(reportType, docNo);
        }}
        SaveAS={SaveAS}
        mode={mode}
      />
      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "488px  auto auto",
            gap: "10px 30px",
          }}
        >
          <div>
            <div className="d-flex align-items-center mb-2">
              <label>วันที่เอกสาร</label>
              <Datetime
                className="input-spacing-input-date"
                name="docDate"
                value={formMasterList.docDate || null}
                onChange={(date) => handleChangeDateMaster(date, "docDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: mode === "U" }}
              />
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>ประเภทใบสั่งซื้อ</label>
              <select
                className="form-select form-control input-spacing"
                name="po_h_doc_po_type"
                value={po_h_doc_po_type}
                onChange={handlesetpo_h_doc_po_type}
                disabled={mode === "U"}
              >
                <option value="1">ต่างประเทศ</option>
                <option value="2">ภายในประเทศ</option>
              </select>
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList.docType}
                onChange={handleChangeMaster}
                disabled={
                  formMasterList.docStatus !== 1 &&
                  formMasterList.docStatus !== 3
                }
              >
                {tbDocType.map((docType) => (
                  <option key={docType.DocType_Id} value={docType.DocType_Id}>
                    {docType.DocType_Name}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>วัตถุประสงค์</label>
              <select
                name="docFor"
                value={formMasterList.docFor}
                onChange={handleChangeMaster}
                className="form-select form-control input-spacing"
                disabled={
                  formMasterList.docStatus !== 1 &&
                  formMasterList.docStatus !== 3
                }
              >
                <option value="1">ซื้อมาเพื่อใช้</option>
                <option value="2">ซื้อมาเพื่อขาย</option>
              </select>
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>Due Date</label>
              <Datetime
                className="input-spacing-input-date"
                name="docDueDate"
                value={formMasterList.docDueDate || null}
                onChange={(date) => handleChangeDateMaster(date, "docDueDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{
                  readOnly: true,
                  disabled: formMasterList.docStatus === 1 ? false : true,
                }}
              />
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>Currency</label>
              <select
                className="form-select form-control input-spacing"
                name="doc_currency"
                value={formMasterList.doc_currency}
                onChange={handleChangeMaster}
                disabled={
                  formMasterList.docStatus !== 1 &&
                  formMasterList.docStatus !== 3
                }
              >
                {Currency.map((docType) => (
                  <option key={docType.cur_code} value={docType.cur_code}>
                    {docType.cur_code}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>Shipment</label>
              <textarea
                type="text"
                className="form-control input-spacing"
                name="doc_shipment"
                value={formMasterList.doc_shipment || ""}
                onChange={handleChangeMaster}
                maxLength={255}
              // disabled={true}
              />
              {/* <select
                name="Doc_Shipment"
                value={formMasterList.Doc_Shipment}
                onChange={handleChangeMaster}
                className="form-select form-control input-spacing"
                disabled={formMasterList.docStatus !== 1 && formMasterList.docStatus !== 3 }
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select> */}
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>Term of Delivery</label>
              <textarea
                type="text"
                className="form-control input-spacing"
                name="doc_delivery"
                value={formMasterList.doc_delivery || ""}
                onChange={handleChangeMaster}
                maxLength={255}
              // disabled={true}
              />
              {/* <select
                name="Doc_Shipment"
                value={formMasterList.Doc_Shipment}
                onChange={handleChangeMaster}
                className="form-select form-control input-spacing"
                disabled={formMasterList.docStatus !== 1 && formMasterList.docStatus !== 3 }
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select> */}
            </div>
          </div>

          <div>
            <div className="mb-2">
              <div className="d-flex align-items-center">
                <label>ผู้ขาย</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="apCode"
                    value={
                      (formMasterList.apCode || "") +
                      " " +
                      (formMasterList.apName || "")
                    }
                    onChange={handleChangeMaster}
                    disabled={true}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleApShow}
                    disabled={
                      formMasterList.docStatus !== 1 &&
                      formMasterList.docStatus !== 3
                    }
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </div>
              <ApModal
                showApModal={showApModal}
                handleApClose={handleApClose}
                apDataList={apDataList}
                onRowSelectAp={onRowSelectAp}
              />
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="apAdd1"
                value={formMasterList.apAdd1 || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>

            <div className="d-flex align-items-center mb-2">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apAdd2 || "") +
                  " " +
                  (formMasterList.apAdd3 || "")
                }
                disabled={true}
              />
            </div>

            <div className="d-flex align-items-center mb-2">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apProvince || "") +
                  " " +
                  (formMasterList.apZipcode || "")
                }
                disabled={true}
              />
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>ผู้ติดต่อ</label>
              {contactList.length > 1 ? (
                <div style={{ width: "100%" }}>
                  <Select
                    options={contactList}
                    value={
                      contactList.find(
                        (opt) => opt.value === formMasterList.doc_contact
                      ) || null
                    }
                    onChange={(selected) => {
                      const selectedContact = selected?.value || "";
                      const ap = apDataList.find(
                        (ap) => ap.AP_Id === formMasterList.apID
                      );

                      let newEmail = "";
                      if (selectedContact === ap?.AP_Contact2) {
                        newEmail = ap?.AP_Email2 || "";
                      } else if (selectedContact === ap?.AP_Contact) {
                        newEmail = ap?.AP_Email || "";
                      }

                      setFormMasterList((prev) => ({
                        ...prev,
                        doc_contact: selectedContact,
                        doc_email: newEmail,
                      }));
                    }}
                    isClearable
                    placeholder="เลือกผู้ติดต่อ"
                  />
                </div>
              ) : (
                <input
                  type="text"
                  name="doc_contact"
                  className="form-control input-spacing"
                  value={formMasterList.doc_contact || ""}
                  onChange={handleChangeMaster}
                />
              )}
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>อีเมลล์</label>
              <input
                type="text"
                name="doc_email"
                className="form-control input-spacing"
                value={formMasterList.doc_email || ""}
                onChange={handleChangeMaster}
              // disabled={true}
              />
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.apTaxNo || ""}
                disabled={true}
              />
            </div>

            <div className="d-flex mb-2">
              <label>ผู้ขอซื้อ</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.prByCode || "") +
                    " " +
                    (formMasterList.prByName || "")
                  }
                  // onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleEmpShow}
                  disabled={
                    formMasterList.docStatus !== 1 &&
                    formMasterList.docStatus !== 3
                  }
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <EmployeeModal
                showEmpModal={showEmpModal}
                handleEmpClose={handleEmpClose}
                empDataList={empDataList}
                onRowSelectEmp={onRowSelectEmp}
              />
            </div>

            <div className="d-flex align-items-center">
              <label>แผนก</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedByName"
                value={deptName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>

          <div style={{ justifyItems: "end" }}>
            <div className="d-flex align-items-center mb-2">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>

            <div className="d-flex align-items-center mb-2">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>

            <div className="d-flex align-items-center text-right mb-2">
              <label>วันที่อนุมัติ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedDate"
                value={formMasterList.approvedDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>

            <div className="d-flex align-items-center text-right mb-2">
              <label>ผู้อนุมัติเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedByName"
                value={formMasterList.approvedByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>

            <div className="d-flex align-items-center text-right mb-2">
              <label>หมายเหตุอนุมัติ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="approvedMemo"
                value={formMasterList.approvedMemo || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>

            <div className="d-flex align-items-center text-right mb-2">
              <label>Ref</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="po_ref"
                value={formMasterList.po_ref || ""}
                onChange={handleChangeMaster}
              // disabled={true}
              />
            </div>
            <div className="d-flex align-items-center  mb-2">
              <label>Term of Payment</label>
              <textarea
                type="text"
                className="form-control input-spacing"
                name="po_term_payment"
                value={formMasterList.po_term_payment || ""}
                onChange={handleChangeMaster}
                maxLength={255}
                style={{ padding: " 0.6rem 1.4rem" }}
              // disabled={true}
              />
            </div>
            <div className="d-flex align-items-center  mb-2">
              <label>Delivery time</label>
              <textarea
                type="text"
                className="form-control input-spacing"
                name="po_deliver_time"
                value={formMasterList.po_deliver_time || ""}
                onChange={handleChangeMaster}
                maxLength={255}
                style={{ padding: " 0.6rem 1.4rem" }}
              />
            </div>

            <div
              className="d-flex align-items-center "
              style={{ justifyContent: "end", marginTop: "20px" }}
            >
              <button
                className="btn text-white mx-3"
                style={{
                  backgroundColor: " rgb(239, 108, 0)",
                  whiteSpace: "nowrap",
                  padding: "15px",
                  fontSize: "15px",
                }}
                onClick={() => handleShowModal()}
              >
                แนบไฟล์
              </button>
              <button
                className="btn text-white mx-3"
                style={{
                  backgroundColor: " rgb(239, 108, 0)",
                  whiteSpace: "nowrap",
                  padding: "15px",
                  fontSize: "15px",
                }}
                onClick={() => setShowViewModal(true)}
                disabled={mode === "I" ? true : false}
              >
                ดูไฟล์ ({selectedFiles?.length})
              </button>
              {showViewModal && (
                <FileModal
                  showModal={showViewModal}
                  handleClose={handleClose}
                  Files={selectedFiles}
                  mode={"U"}
                  handleRemoveImage={handleRemoveImage}
                />
              )}
            </div>
          </div>
        </div>

        <div className="row mt-1"></div>

        <hr />
        <div className="row mt-2">
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <textarea
                type="text"
                className=" input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                style={{ height: "65px" }}
                disabled={
                  formMasterList.docStatus !== 1 &&
                  formMasterList.docStatus !== 3
                }
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                maxLength={255}
                disabled={
                  formMasterList.docStatus !== 1 &&
                  formMasterList.docStatus !== 3
                }
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <ItemTable
            formDetailList={formDetailList}
            handleChangeDetail={handleChangeDetail}
            handleDuplicateRow={handleDuplicateRow}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            onRowSelectItem02={onRowSelectItem02}
            showAddEmptyButton={po_h_doc_po_type === "2"}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            setFormDetailList={setFormDetailList}
            disabled={
              formMasterList.docStatus !== 1 && formMasterList.docStatus !== 3
            }
            onRowSelectItemForEdit={onRowSelectItemForEdit}
          />
          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={
              formMasterList.docStatus !== 1 && formMasterList.docStatus !== 3
            }
          />
        </div>
      </div>

      <br />
      {showConfirmModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">ยืนยันการปิดงาน PO</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setShowConfirmModal(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>คุณแน่ใจหรือไม่ว่าต้องการปิดงานใบ PO นี้?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowConfirmModal(false)}
                >
                  ยกเลิก
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirmUpdateStatus}
                >
                  ยืนยัน
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        handleConfirmtModalBeforeUpdate={handleOpenConfirmModal}
        mode={mode}
        disabled={
          formMasterList.docStatus !== 1 && formMasterList.docStatus !== 3
        }
        footer={true}
        docedit={docedit}
        docStatus={formMasterList.docStatus}
        maxDocNo={maxDocNo}
      />
    </>
  );
}

export default Form;
